import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

/**
 * @typedef {Array<string>} CountByTypeOnlyMineExternalReducer
 */
const initialState = [];

/**
 *
 * @param {CountByTypeOnlyMineExternalReducer} _
 * @param {import('modules/chat/types').FetchUnreadCountsByTypeSuccessAction} action
 * @returns {CountByTypeOnlyMineExternalReducer}
 */
const update = (_, { payload }) => payload.external.onlyMine;

/**
 * @param {CountByTypeOnlyMineExternalReducer} state
 * @param {import('modules/sockets/types/actions').PutSocketMessageAction & { payload: { data: { message: import('modules/chat/types/message').Message, myClients: boolean } } }} action
 * @returns {CountByTypeOnlyMineExternalReducer}
 */
const updateFromNewMessage = (state, { payload }) => {
  const { message, myClients } = payload;
  return !state.includes(message.conversationId) && myClients ? [...state, message.conversationId] : state;
};

export default createReducer(initialState, {
  [actionTypes.FETCH_UNREAD_COUNTS_BY_TYPE_SUCCESS]: update,
  [actionTypes.RECEIVE_MESSAGE_FROM_SOCKET]: updateFromNewMessage,
});
